<template>
    <div class="container-fluid">

        <hr class="my-4"/>

        <div class="row">
            <div class="col-1 px-0 pt-2">
                <ScToggleOnOff :active="isEnabled"
                               :loading="showLoading"
                               @sc-toggle="toggleEnableViewerTags()"></ScToggleOnOff>
            </div>
            <div class="col-11">
                <h4>Enable Viewer tags</h4>
                <small class="d-block">
                    When enabled, Viewers can assign tags to collate custom slideshows.
                </small>
            </div>
        </div>

    </div>
</template>

<script>
    import ScNotification from '../../shared/common/ScNotification.vue';
    import ScToggleOnOff from '../../shared/common/ScToggleOnOff.vue';
    import MainAppMixin from '../MainAppMixin';
    import $ from 'jquery';

    let DataManager = {
        loadData (vm) {
            vm.showLoading = true;
            vm.isEnabled = true;
            $.ajax({
                type: 'GET', url: "/main/presentations/ajax_load_user_tags_enabled",
                data: { workspace_id: vm.workspaceId, presentation_id: vm.presentationId }
            }).done(function(data){
                if (data.user_tags_enabled === null)
                    vm.isEnabled = false;
                else
                    vm.isEnabled = !!data.user_tags_enabled;
            }).fail(function(jqXhr) {
                ScNotification.growlXhrError(jqXhr, "loading data");
            }).always(function() {
                vm.showLoading = false;
            });
        },
        updateData (vm) {
            vm.showLoading = true;
            $.ajax({
                type: 'POST', url: "/main/presentations/ajax_save_user_tags_enabled",
                data: {
                    workspace_id: vm.workspaceId,
                    presentation_id: vm.presentationId,
                    user_tags_enabled: vm.isEnabled
                }
            }).done(function(data) {
                if (data.status === 'error') {
                    ScNotification.growlErrMsg('Change NOT saved. Please reload this page and try again. ' +
                        'If problem continues please contact support.');
                } else {
                    ScNotification.growlSuccessMsg('Saved.');
                }
            }).fail(function() {
                ScNotification.growlErrMsg('Change NOT saved. Please reload this page and try again. ' +
                    'If problem continues please contact support.');
            }).always(function() {
                vm.showLoading = false;
            });
        }
    };

    export default {
        name: "ManageViewerTags",
        components: { ScToggleOnOff },
        mixins: [ MainAppMixin ],
        props: {
            workspaceId: {type: Number, default: null},
            presentationId: {type: Number, default: null}
        },
        data () {
            return {
                isEnabled: true,
                showLoading: false
            };
        },
        mounted () {
            DataManager.loadData(this);
        },
        methods: {
            toggleEnableViewerTags () {
                this.isEnabled = !this.isEnabled;
                DataManager.updateData(this);
            },
        }
    }
</script>
